import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { ApiResponseInterceptor, TenantApiKeyInterceptor } from './core/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),

    // Register the DI-based interceptors
    provideHttpClient(withInterceptorsFromDi()),

    /**
     * TenantApiKeyInterceptor — injects X-API-Key header based on domain.
     *
     * Automatically detects the current domain/subdomain and injects the
     * appropriate API Key for multi-tenant authentication:
     * - localhost → HMRS pre-prod API Key
     * - hmrs.tudominio.com → HMRS prod API Key
     * - hospitalb.tudominio.com → Hospital B prod API Key
     *
     * This interceptor runs FIRST to ensure the API Key is set before
     * the request reaches the backend.
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenantApiKeyInterceptor,
      multi: true,
    },

    /**
     * ApiResponseInterceptor — unwraps the backend envelope automatically.
     *
     * The NestJS TransformInterceptor wraps every response as:
     *   { success: boolean, data: T, timestamp: string }
     *
     * This interceptor extracts `data` so all services receive the payload
     * directly without manual envelope navigation.
     *
     * This interceptor runs AFTER TenantApiKeyInterceptor to process
     * the response from the backend.
     */
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiResponseInterceptor,
      multi: true,
    },
  ],
};
